import React, {useState, VFC} from "react";
import {useSelector} from "react-redux";
import {TSitecoreJssFormProps} from "./types/SitecoreJssForm.type";
import {Form} from "@sitecore-jss/sitecore-jss-react-forms";
import defaultFieldFactory from "./fieldFactory";
import FieldValidationError from "./components/fieldValidationError";
import fieldWrapper from "./components/fieldWrapper";
import {withRouter} from "react-router-dom";
import {sitecoreApiHost, sitecoreApiKey} from "../../../temp/config";
import {isInternalUrl} from "../../utils/linkUtils";
import "./styles.scss";
import JssForm from "../SitecoreJssForm/components/JssForm/JssForm";
import LazySection from "../../react-only-components/LazySection";
import Spinner from "../../react-only-components/Spinner/Spinner";

const SitecoreJssForm: VFC<TSitecoreJssFormProps> = (props) => {
  const {fields, history} = props;

  const fieldsData = useSelector((state: any) => {
    return state.fields;
  });

  const loader = useSelector((state: any) => {
    return state.loader;
  });

  // console.log(fields);

  return (
    <section>
      {loader && <Spinner></Spinner>}
      <section className="sitecore-jss-form">
        <JssForm
          form={fields}
          sitecoreApiHost={sitecoreApiHost}
          sitecoreApiKey={sitecoreApiKey}
          fieldFactory={defaultFieldFactory}
          errorComponent={() => <></>}
          fieldValidationErrorsComponent={FieldValidationError}
          fieldWrapperComponent={fieldWrapper}
          onRedirect={(url) => {
            if (isInternalUrl(url)) {
              history.push(url);
            } else {
              window.location.href = url;
            }
          }}
        />
      </section>
    </section>
  );
};

export default withRouter(SitecoreJssForm);
